import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

import ReferenceFormat from './reference/ReferenceFormat.jsx';

const FormatBold = styled.span`
    font-weight: bold;
`;

const FormatSuperBold = styled.span`
    font-weight: bold;
    font-size: 1.15rem;
`;

const Dot = styled.span`
    font-weight: bold;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    color: black;
`;

export class TextFormat extends Component {

    static propTypes = {
        text: PropTypes.string.isRequired,
        is_first: PropTypes.bool,
        of_many: PropTypes.bool,
        on_reference_click: PropTypes.func,
        references: PropTypes.object
    }

    static defaultProps = {
        is_first: true,
        of_many: false
    }

    state = {
        on_reference_click: this.props.on_reference_click ?
            this.props.on_reference_click : this.on_reference_click,
        references: this.props.references ? this.props.references : {}
    }

    on_reference_click(reference) {
        console.log("on_reference_click misfired in TextFormat", reference)
    }

    bold = (text, is_first = false) => {
        const {on_reference_click, references} = this.state;
        if (!text) {
            return [];
        }
        const bold = /\*\*(.*?)\*\*/gim;
        return text.split(bold).map((s, i) => {
            const rf = <ReferenceFormat
                key={'boldtext_' + i} text={s}
                on_reference_click={reference => on_reference_click(reference)}
                references={references}/>
            return i % 2 ? (is_first ?
                    <FormatSuperBold key={"superbold_" + i}>{rf}</FormatSuperBold> :
                    <FormatBold key={"bold_" + i}>{rf}</FormatBold>
            ) : rf
        });
    }

    render() {
        const {text, is_first, of_many} = this.props;
        const text_blocks = this.bold(text, is_first && of_many);
        let all_blocks = [];
        if (!is_first && of_many) {
            const dot = <span key={all_blocks.length}><Dot>{String.fromCharCode(183)}</Dot><wbr/></span>
            all_blocks.push(dot)
        }
        for (let i = 0; i < text_blocks.length; i++) {
            all_blocks.push(text_blocks[i]);
        }
        return <span style={{userSelect: 'none'}}>{all_blocks}</span>;
    }
}

export default TextFormat;
